import {
  DefaultServerService,
  isLocalWorkspaceEnabled,
} from '@affine/core/modules/cloud';
import { useLiveData, useService } from '@toeverything/infra';

export function useLocalWorkspaceEnabled(): boolean {
  const defaultServerService = useService(DefaultServerService);
  return useLiveData(
    defaultServerService.server.config$.selector(isLocalWorkspaceEnabled)
  );
}
